import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса «Создание по умолчанию» базы 1С (RP-SYN11): поля новой карточки из
 * синхронизации, справочники для выбора и сохранённые умолчания. Литерал
 * `/api/` законен только здесь.
 */
const base = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}`

export const ONEC_CREATE_DEFAULTS_URLS = {
  defaults: (resourceId: string) => `${base(resourceId)}/catalog/create-defaults`,
} as const
